import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import 'moment-timezone';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public err: any = {};
  public result: any = {};
  public data: any = {};
  public form: any = {};
  public start_date = moment().subtract(29, 'days');
//  public alert: any = {};
  header_data: any =
    {
      heading: "Login",
    };
    
  constructor(private service: LoginService, private router: Router, public fb: FormBuilder) { 
    this.service.setTitle('Login | 24ieye');
    
    this.form = this.fb.group({
      email: [''],
      password: ['']
    });
    
//    this.alert = {'type': '', message: ''}
  }
    
  ngOnInit(): void {
      
  }
  
  public async doLogin() {  
        var formData: any = new FormData();
        formData.append("email", this.form.value.email);
        formData.append("password", this.form.value.password);

        this.result = await this.service.form_actions(formData, 'login');
        if (this.result.status == false) {
                if (this.result.code == 202) {
                  this.err = {};
                  Swal.fire('Alert!', this.result.message, 'error');
                } else {
                  this.err = this.result.errors;
                }
        } else {
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
            this.saveSession(this.result.data);
            if(this.result.data.role == 2){ 
                this.service.create_log(this.result.data.id, 'login');
            }
            if(this.result.data.last_login){
                setTimeout(() => {
                    this.router.navigate(['projects']);
                  }, 2000);
            } else {
                setTimeout(() => {
                    this.router.navigate(['change-password']);
                  }, 2000);
            }
        }
      }
      
saveSession(data) { 
//    localStorage.setItem('session_login', true);
    localStorage.setItem('ieye_session_id', data.id);
    localStorage.setItem('ieye_session_name', data.name);
    localStorage.setItem('ieye_session_email', data.email);
    localStorage.setItem('ieye_session_role', data.role);
    localStorage.setItem('ieye_session_start_date', this.startDate());
    localStorage.setItem('ieye_session_end_date', this.endDate());
}

public startDate(){
    return moment().subtract(29, 'days').format("YYYY-MM-DD");
}

public endDate(){
    return moment().format("YYYY-MM-DD");
}

}
